import { track } from '@/utils/analytics';

const handleTrackFilter = (name) => {
  track(`filter - ${name}`);
};

export default handleTrackFilter;
